import Dimension from './src/main';

/* istanbul ignore next */
Dimension.install = function(Vue) {
  Vue.component(Dimension.name, Dimension);
};

export default Dimension;
